import { createFileRoute } from '@tanstack/react-router'

import { authProviderAtom, authStore } from '@/features/auth/atoms'

export const Route = createFileRoute('/_public/login')({
  beforeLoad: async () => {
    authStore.set(authProviderAtom, `AUTH0`)
  }
})
